
// src/msalAuth.ts
import * as msal from "@azure/msal-browser";
import LoggingService from './services/LoggingService';

// Configure MSAL
const msalConfig = {
  auth: {
    clientId: "dc97a0f2-d73a-4184-8bfe-0c10ed7ff5df", // your client id
    authority: "https://login.microsoftonline.com/b24752cf-dca1-4cd9-8094-aeeb93913ea5", // your tenant id here
    redirectUri: window.location.origin
  }
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

// Define the request scopes for SharePoint or Graph (update scope as needed)
export const tokenRequest = {
  scopes: ["https://netorgft10863452.sharepoint.com/.default"]
};

// Helper function: Ensure an active account is set.
export const setActiveAccountIfNeeded = () => {
  const currentAccounts = msalInstance.getAllAccounts();
  if (currentAccounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(currentAccounts[0]);
  }
};

export const getMsalToken = async (): Promise<string> => {
  try {
    LoggingService.info("Getting MSAL token", {}, "MsalAuth");
    
    // If no accounts, force an interactive login.
    if (msalInstance.getAllAccounts().length === 0) {
      LoggingService.info("No accounts found, initiating login popup", {}, "MsalAuth");
      const loginResponse = await msalInstance.loginPopup(tokenRequest);
      msalInstance.setActiveAccount(loginResponse.account);
    }
    
    // Ensure we have an active account.
    setActiveAccountIfNeeded();
    const activeAccount = msalInstance.getActiveAccount();
    if (!activeAccount) {
      throw new Error("No active account available");
    }
    
    // Pass the active account into acquireTokenSilent.
    const response = await msalInstance.acquireTokenSilent({ ...tokenRequest, account: activeAccount });
    return response.accessToken;
    
  } catch (error) {
    LoggingService.error("acquireTokenSilent failed, falling back to popup", error, "MsalAuth");
    // Fallback to interactive token acquisition.
    const response = await msalInstance.acquireTokenPopup(tokenRequest);
    if (response.account) {
      msalInstance.setActiveAccount(response.account);
    }
    return response.accessToken;
  }
};

// Export everything as a single object as well
export default {
  msalInstance,
  tokenRequest,
  setActiveAccountIfNeeded,
  getMsalToken
};
